import { GraphQLClient } from 'graphql-request'
import type { RequestMiddleware } from 'graphql-request/dist/types'
import { useLocalStorage } from '@vueuse/core'
import { LOCAL_STORAGE_KEYS } from '~/constants'

export function useRequester() {
  const token = useLocalStorage<string | null>(LOCAL_STORAGE_KEYS.TOKEN, null)
  const GRAPHQL_ENDPOINT = useRuntimeConfig().public.GRAPHQL_ENDPOINT
  // @ts-expect-error impossible to type
  const requestMiddleware: RequestMiddleware = async (request) => {
    const rawToken = token.value
    return {
      ...request,
      headers: {
        Authorization: rawToken ? `Bearer ${rawToken}` : '',
        ...request.headers,
      },
    }
  }

  const client = new GraphQLClient(GRAPHQL_ENDPOINT, { requestMiddleware })
  return {
    requester: client.request.bind(client),
  }
}
